import React from 'react';
import { IPhraseListPlayControlsProps } from './types';
import { theme } from '../../../../../common/styles/theme';
import { Stack, SxProps } from '@mui/material';
import { EPhraseListPlayMode } from '../../../../store/phrase-list/types';
import { CLASS_PLAY_CONTROL } from '../../Video/components/constants';
import { PlayButton } from '../../PlayButton/components/PlayButton';
import { ArrowIcon } from '../../../../../../icons/ArrowIcon';
import { ArrowLightLeftIcon } from '../../../../../../icons/ArrowLightLeftIcon';

export const PhraseListPlayControls: React.FC<IPhraseListPlayControlsProps> = ({
	status,
	onPlay,
	onStop,
	onPrev,
	onNext,
}) => {
	const className = 'phrases-list-play-controls';

	const prevSx: SxProps = {
		position: 'relative',
		justifyContent: 'center',
		alignItems: 'center',
		width: theme.spacing(3.5),
		height: theme.spacing(3.5),
		color: theme.palette.common.white,
		background: theme.palette.grey[300],
		borderRadius: '50%',
		cursor: 'pointer',
		transition: 'all .3s ease',

		'svg': {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
		},

		'&:before': {
			content: '""',
			position: 'absolute',
			inset: '-5px',
		},

		'&:hover, &:focus': {
			background: theme.palette.grey[400],
		},
	};

	return (
		<Stack
			className={className}
			direction='row'
			alignItems={'center'}
			gap={.5}
			sx={{
				'.play-button': {
					width: theme.spacing(4),
					height: theme.spacing(4),
				},
			}}
		>
			<Stack
				className={CLASS_PLAY_CONTROL}
				sx={prevSx}
				onClick={onPrev}
			>
				<ArrowLightLeftIcon />
			</Stack>

			<PlayButton
				className={CLASS_PLAY_CONTROL}
				isPlay={EPhraseListPlayMode.PLAY === status}
				onClick={EPhraseListPlayMode.PLAY === status ? onStop : onPlay}
			/>

			<Stack
				className={CLASS_PLAY_CONTROL}
				sx={{
					...prevSx,
	
					'svg': {
						transform: 'scaleX(-1)',
					},
				}}
				onClick={onNext}
			>
				<ArrowLightLeftIcon />
			</Stack>

		</Stack>					
	);
};
